import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type ReceiptMismatchIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function ReceiptMismatchIcon(props: ReceiptMismatchIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  const strokeColor = props.fill || '#D5404A'
  return (
    <svg
      className={cn('ReceiptMismatchIcon', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={ariaLabel ?? translate('Receipt mismatched')}
      {...rest}
    >
      <path
        d="M3.625 2.62955C3.625 2.36434 3.73036 2.10998 3.91789 1.92245C4.10543 1.73491 4.35978 1.62955 4.625 1.62955C4.87262 1.62819 5.11548 1.69758 5.325 1.82955L6.258 2.42955C6.46704 2.56313 6.70993 2.63411 6.958 2.63411C7.20607 2.63411 7.44896 2.56313 7.658 2.42955L8.592 1.82955C8.80104 1.69598 9.04393 1.625 9.292 1.625C9.54007 1.625 9.78296 1.69598 9.992 1.82955L10.925 2.42955C11.134 2.56313 11.3769 2.63411 11.625 2.63411C11.8731 2.63411 12.116 2.56313 12.325 2.42955L13.258 1.82955C13.467 1.69598 13.7099 1.625 13.958 1.625C14.2061 1.625 14.449 1.69598 14.658 1.82955L15.592 2.42955C15.801 2.56313 16.0439 2.63411 16.292 2.63411C16.5401 2.63411 16.783 2.56313 16.992 2.42955L17.925 1.82955C18.1345 1.69758 18.3774 1.62819 18.625 1.62955C18.8902 1.62955 19.1446 1.73491 19.3321 1.92245C19.5196 2.10998 19.625 2.36434 19.625 2.62955V20.6296C19.625 20.8948 19.5196 21.1491 19.3321 21.3367C19.1446 21.5242 18.8902 21.6296 18.625 21.6296C18.3774 21.6309 18.1345 21.5615 17.925 21.4296L16.992 20.8296C16.783 20.696 16.5401 20.625 16.292 20.625C16.0439 20.625 15.801 20.696 15.592 20.8296L14.658 21.4296C14.449 21.5631 14.2061 21.6341 13.958 21.6341C13.7099 21.6341 13.467 21.5631 13.258 21.4296L12.325 20.8296C12.116 20.696 11.8731 20.625 11.625 20.625C11.3769 20.625 11.134 20.696 10.925 20.8296L9.992 21.4296C9.78296 21.5631 9.54007 21.6341 9.292 21.6341C9.04393 21.6341 8.80104 21.5631 8.592 21.4296L7.658 20.8296C7.44896 20.696 7.20607 20.625 6.958 20.625C6.70993 20.625 6.46704 20.696 6.258 20.8296L5.325 21.4296C5.11548 21.5615 4.87262 21.6309 4.625 21.6296C4.35978 21.6296 4.10543 21.5242 3.91789 21.3367C3.73036 21.1491 3.625 20.8948 3.625 20.6296V2.62955Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.80005 8.80002L13.80005 14.80002"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <path
        d="M13.80005 8.80002L8.80005 14.80002"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  )
}
